import { CSV_MAPPING_ACTION_TYPE } from '../actions';

const initialState = {};

const csvMappingPropertiesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CSV_MAPPING_ACTION_TYPE.GET_CSV_MAPPING_PROPS:
    case CSV_MAPPING_ACTION_TYPE.EDIT_CSV_MAPPING_PROPS:
      return payload || state;

    case CSV_MAPPING_ACTION_TYPE.RESET_CSV_MAPPING_PROPS:
      return initialState;

    default:
      return state;
  }
};

export default csvMappingPropertiesReducer;
